// extracted by mini-css-extract-plugin
export var root = "hC-y";
export var rootBody = "HijE";
export var rootCloseFooter = "eh4k";
export var rootContainer = "v62g";
export var rootIconLoading = "rHRT";
export var rootInput = "_0iQO";
export var rootInputWrapper = "d6ew";
export var rootNotFound = "dsEl";
export var rootPopular = "+cfL";
export var rootPopularButton = "UKj9";
export var rootPopularHeading = "jG6u";
export var rootPopularList = "YzPB";
export var rootSearching = "P0cF";
export var rootSubmit = "wgX5";